/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ b: NonNullable<unknown> }} Battery_NewInputs */



/**
* | output |
* | --- |
* | "New battery inserted ({b})" |
*
* @param {Battery_NewInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const battery_new = /** @type {((inputs: Battery_NewInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Battery_NewInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`New battery inserted (${i?.b})`)
	return /** @type {LocalizedString} */ (`Nouvelle pile insérée (${i?.b})`)
});